import axios from 'axios'

export default class ListaEstados {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/unimed/enderecos/estados`
    this.tokenBearer = tokenBearer
  }

  getEstados () {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: this.url,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
